export enum DocumentType {
  AtRiskRequest = "AT_RISK_REQUEST",
  BenefitPlan = "BENEFIT_PLAN",
  CompanyLogo = "COMPANY_LOGO",
  Contract = "CONTRACT",
  Check= "CHECK",
  ContractModification = "CONTRACT_MODIFICATION",
  CustomerInvoice = "CUSTOMER_INVOICE",
  EmployeeApplication = "EMPLOYEE_APPLICATION",
  ExpenseReceipt = "EXPENSE_RECEIPT",
  ExpenseReport = "EXPENSE_REPORT",
  FinancialReport = "FINANCIAL_REPORT",
  ItemReceipt = "ITEM_RECEIPT",
  ItemReturn = "ITEM_RETURN",
  LeaseAgreement = "LEASE_AGREEMENT",
  MaterialOrder = "MATERIAL_ORDER",
  NDAgreement = "ND_AGREEMENT",
  OrgAccount = "ORG_ACCOUNT",
  OrgInvoice = "ORG_INVOICE",
  OrgDocument = "ORG_DOCUMENT",
  OrgPayrollTax = "ORG_PAYROLL_TAX",
  OrgPolicy = "ORG_POLICY",
  OnboardPolicyAck = "ONBOARDING_POLICY_ACK",
  OnboardDocumentAck = "ONBOARDING_DOCUMENT_ACK",
  PartnerAccount = "PARTNER_ACCOUNT",
  PartnerCorrespondence = "PARTNER_CORRESPONDENCE",
  Project = "PROJECT",
  PurchaseRequisition = "PURCHASE_REQUISITION",
  Resume = "RESUME",
  SalesOrder = "SALES_ORDER",
  StatementOfWork = "STATEMENT_OF_WORK",
  SubcontractAgreement = "SUBCONTRACT_AGREEMENT",
  Template = "TEMPLATE",
  OrgFile = "ORG_FILE",
  Thumbnail = "THUMBNAIL",
  Timesheet = "TIMESHEET",
  TimesheetCorrection = "TIMESHEET_CORRECTION",
  VendorInvoice = "VENDOR_INVOICE",
  QLERequest = "QLE_REQUEST",
  SupportingDoc = "SUPPORTING_DOC",
  Letter = "LETTER",
  W4Form = "W4_FORM",
  Passport = "PASSPORT",
  License = "LICENSE",
  IdCard = "ID_CARD",
  OrgSignedContract = "ORG_SIGNED_CONTRACT",
  Other = "OTHER"
}
